import { render, staticRenderFns } from "./NewCurve.vue?vue&type=template&id=07fe342c&scoped=true"
import script from "./NewCurve.vue?vue&type=script&lang=ts"
export * from "./NewCurve.vue?vue&type=script&lang=ts"
import style0 from "./NewCurve.vue?vue&type=style&index=0&id=07fe342c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07fe342c",
  null
  
)

export default component.exports